import { useCallback, useState } from 'react';

import { BoardThemePreview } from '@ui/components/BoardThemePreview/BoardThemePreview';
import { PopoverMenuItem } from '@ui/components/PopoverMenu/PopoverMenu';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';

import { BoardThemeSubMenu } from '../UserSettingsMenu/BoardThemeSubMenu';

export function SiteSettingsMenuItems({
  theme,
  toggleTheme,
  autoQueen,
  toggleAutoQueen,
  boardTheme,
  setBoardTheme,
  boardSounds = 'none',
  setBoardSounds,
}: UserSettingsProps) {
  const [subMenu, setSubMenu] = useState<'boardTheme' | null>(null);

  const toggleBoardSounds = useCallback(() => {
    setBoardSounds(boardSounds === 'none' ? 'default' : 'none');
  }, [boardSounds, setBoardSounds]);

  return (
    <>
      <PopoverMenuItem onClick={toggleTheme}>
        <div>Тема оформления</div>
        <div>{theme === 'dark' ? 'Темная' : 'Светлая'}</div>
      </PopoverMenuItem>
      <PopoverMenuItem onClick={toggleAutoQueen}>
        <div>Автоферзь</div>
        <div>{autoQueen ? 'Включен' : 'Отключен'}</div>
      </PopoverMenuItem>
      <PopoverMenuItem onClick={toggleBoardSounds}>
        <div>Звуки</div>
        <div>{boardSounds === 'none' ? 'Отключены' : 'Включены'}</div>
      </PopoverMenuItem>
      <PopoverMenuItem onClick={() => setSubMenu('boardTheme')}>
        <div>Цвет доски</div>
        <BoardThemePreview boardTheme={boardTheme} />
      </PopoverMenuItem>

      <BoardThemeSubMenu
        isOpen={subMenu === 'boardTheme'}
        onClose={() => setSubMenu(null)}
        boardTheme={boardTheme}
        setBoardTheme={setBoardTheme}
      />
    </>
  );
}
